<template>
	<ul v-if="dataItem" role="menu" >
		<template v-for="(item,i) of dataItem">
			<li :key="i || i" role="none" v-if="visible(item) && !item.separator"
				:class="[{'active-rootmenuitem':activeIndex === i && root && layoutMode === 'horizontal' && !item.disabled,
			'active-menuitem': (($route.meta.breadcrumb && item.label === $route.meta.breadcrumb[0].parent && layoutMode === 'horizontal') ||
			(activeIndex === i && layoutMode !== 'horizontal') || (activeIndex === i && !root && layoutMode === 'horizontal')) && !item.disabled}]" >
				
				<router-link v-if="item.to" :to="item.to" :style="item.style" :class="[item.class, 'p-ripple', {'p-disabled': item.disabled}]" :target="item.target" exact
							@click.native="onMenuItemClick($event,item,i)" @mouseenter.native="onMenuItemMouseEnter(i)" role="menuitem" v-ripple>
						<i :class="['layout-menuitem-icon',item.icon]"></i>
						<span class="layout-menuitem-text">{{item.label}}</span>
						<i v-if="item.items" class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
				</router-link>

				<a v-if="!item.to && item.label !== 'Search'" :href="item.url||'#'" :style="item.style" :class="[item.class, 'p-ripple', {'p-disabled': item.disabled}]" :target="item.target"
						@mouseenter="onMenuItemMouseEnter(i)" @click="onMenuItemClick($event,item,i)" role="menuitem" v-ripple>
						<i :class="['layout-menuitem-icon',item.icon]"></i>
						<span class="layout-menuitem-text">{{item.label}}</span>
						<i v-if="item.items" class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
				</a>
				
				<div v-if="item.label === 'Search'">
					<div class="SearchMenu ">
						<div class="Box_SearchMenu ">
							<input v-model="inputSearchMenu" class="input_SearchMenu "  placeholder="ค้นหาข้อมูล"/>
							<i class="pi pi-times iconSearchMenu" style="font-size: 1.1rem" @click="Menu_Clear_Search()"></i>
						</div>			
					</div>	
				</div>
				
				<transition name="layout-submenu-container">
					<AppSubmenu v-show="activeIndex === i" :items="visible(item) && item.items" :menuActive="menuActive" :layoutMode="layoutMode" :parentMenuItemActive="activeIndex === i" 
								@menuitem-click="$emit('menuitem-click', $event)" class="sub_menu"
								></AppSubmenu>
				</transition>
			</li>
			<li class="p-menu-separator" :style="item.style" v-if="visible(item) && item.separator" :key="'separator' + i" role="separator"></li>
		</template>
	</ul>
</template>
<script>
	import EventBus from './event-bus';

	export default {
		name: 'AppSubmenu',
		props: {
			items: Array,
			layoutMode: String,
			menuActive: Boolean,
			root: {
				type: Boolean,
				default: false
			},
			parentMenuItemActive: {
				type: Boolean,
				default: false
			}
			
		},
		data() {
			return {
				activeIndex : null,
				// menuActive: true,
				// root: {
				// 	type: true,
				// 	default: false
				// },
				// parentMenuItemActive: {
				// 	type: true,
				// 	default: false
				// }
				dataItem : this.items,
				inputSearchMenu : "",
			}
		},
		watch: {
			inputSearchMenu: function(val) {
				let data = this.items.filter((item) => {
					return item.label.includes(val)
				})
				let dataUnshift = []
				for (let index = 0; index < data.length; index++) {
					const element = data[index];
					dataUnshift.push(element.label)
				}
				if (!dataUnshift.includes('Search')) {
					data.unshift(
							{
							label: 'Search', 
							}
						);
				}
				this.dataItem = data
			},
			items: function() {
				this.dataItem = this.items
			}
		},
		mounted() {
			EventBus.$on('reset_active_index', () => {
				if((this.layoutMode === 'horizontal')) {
					this.activeIndex = null;
				}
			});
		},
		methods: {
			onMenuItemClick(event, item, index) {
				this.Menu_Clear_Search()
				if (item.disabled) {
					event.preventDefault();
					return;
				}

				//execute command
				if (item.command) {
					item.command({originalEvent: event, item: item});
					event.preventDefault();
				}

				this.activeIndex = (this.activeIndex === index) ? null : index;

				if (item.items) {
					event.preventDefault();
				}

				if (this.root) {
					this.$emit('root-menuitem-click', {
						originalEvent: event
					});
				}
				this.$emit('menuitem-click', {
					originalEvent: event,
					item: item
				});
			},
			isMobile() {
				return window.innerWidth <= 1025;
			},
			onMenuItemMouseEnter(index) {
				
				if(this.root && this.menuActive && (this.layoutMode === 'horizontal') && !this.isMobile()) {
					this.activeIndex =  index;
				}
			},
			visible(item) {
				return (typeof item.visible === 'function' ? item.visible() : item.visible !== false);
			},
			Menu_Clear_Search(){
				this.inputSearchMenu = ""	
			},
		},
		components: {
			"AppSubmenu": this
		}
	}
</script>

<style scoped>
.input_SearchMenu{
	width: 100%;
	border: none;
	font-size: 1.05rem;
	font-weight: 400;
	
}
.Box_SearchMenu{
	width: 100%;
	max-width: 255px;
	padding: 7px 10px;
	border: 1px solid #b0b0b0; 
	border-radius: 5px;

	display: flex;
	justify-content: space-between;
	align-items: center;
}
.Box_SearchMenu .iconSearchMenu:hover {
 cursor: pointer;
}
.input_SearchMenu:focus{
	outline: none;
}
.SearchMenu{
	margin: auto;
	padding: 3.5px 7px 3.5px 7px;
}
@media screen and (max-width: 992px) {
	.SearchMenu{
		padding: 3.5px 7px 3.5px 42px;
	}
    .Box_SearchMenu{
		max-width: 100%;
	}
}

.sub_menu{
	width: 120%;
}
.sub_menu::-webkit-scrollbar {
    width: 0;
    height: 0px;
    
  }
  
@media screen and (max-width: 992px) {
    .sub_menu{
	width: 100%;
	}
}
</style>
